// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"src-routes-Chat__mainContainer__3IqBt","mainChild":"src-routes-Chat__mainChild__wPzQf","messageList":"src-routes-Chat__messageList__1_Zs7","messageContainer":"src-routes-Chat__messageContainer__3sRzy","fadein":"src-routes-Chat__fadein__RhG-4","footer":"src-routes-Chat__footer__PeBgr","loginBox":"src-routes-Chat__loginBox__2ecae"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Chat.css
// module id = 365
// module chunks = 0